// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。

// 実績の一覧データ。並び順＝一覧での表示順。cover はカード上部の中身（JSX）。isCover は画像の代わりに紺地の表紙を出すもの。
export const CASES = [
  {
    slug: "anybound",
    meta: "株式会社JTB",
    title:
      "希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」",
    tags: ["エンタープライズ", "ブロックチェーン事業開発", "共創プロジェクト"],
    isCover: false,
    cover: (
      <>
        <img
          src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
          alt=""
        />
      </>
    ),
  },
  {
    slug: "kanda-curry",
    meta: "広告代理店",
    title: "スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」",
    tags: ["イベント・観光", "ブロックチェーン事業開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">NFT STAMP RALLY</span>
        <span className="cover-ja">スタンプラリー × NFT</span>
      </>
    ),
  },
  {
    slug: "premience",
    meta: "株式会社JTB",
    title:
      "JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル",
    tags: ["旅行・観光", "ブランディング・Web制作"],
    isCover: false,
    cover: (
      <>
        <img src="/assets/images/case-premience.jpg" alt="" />
      </>
    ),
  },
  {
    slug: "hikky",
    meta: "メタバース事業会社",
    title: "メタバース霊園の土地と遺品を、NFTで受け継げる仕組みに",
    tags: ["メタバース・エンタメ", "ブロックチェーン事業開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">METAVERSE NFT</span>
        <span className="cover-ja">メタバース × NFT</span>
      </>
    ),
  },
  {
    slug: "ehon",
    meta: "絵本出版社",
    title:
      "20年後に開封される、絵本のデジタルタイムカプセル「ÉHON TIME CAPSULE」",
    tags: ["出版", "ブロックチェーン事業開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">DIGITAL TIME CAPSULE</span>
        <span className="cover-ja">絵本 × NFT</span>
      </>
    ),
  },
  {
    slug: "pizzaday",
    meta: "株式会社Spicelink",
    title:
      "サステナブルアパレルブランドに、NFTと暗号資産決済を組み込んだECを構築",
    tags: ["アパレル・ファッション", "ブロックチェーン事業開発"],
    isCover: false,
    cover: (
      <>
        <img
          src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/main-11-884x600-1.jpg"
          alt=""
        />
      </>
    ),
  },
  {
    slug: "nasushiobara",
    meta: "株式会社Spicelink・那須塩原市",
    title:
      "ウール肥料で育てたワインを、NFTの引換券で届ける「ウールとワインと那須塩原のWA！」",
    tags: ["地域創生", "ブロックチェーン事業開発"],
    isCover: false,
    cover: (
      <>
        <img src="/assets/images/case-nasushiobara.jpg" alt="" />
      </>
    ),
  },
  {
    slug: "kids-art",
    meta: "鉄道グループの保育・教育事業会社",
    title: "卒園児が描いた絵を、「この世にひとつ」のデジタル絵として残す",
    tags: ["教育・保育", "ブロックチェーン事業開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">DIGITAL ART NFT</span>
        <span className="cover-ja">卒園記念 × NFT</span>
      </>
    ),
  },
  {
    slug: "tcg",
    meta: "トレーディングカード販売会社",
    title: "日本のトレーディングカードを、NFTで米国のコレクターに届けるPoC",
    tags: ["トレーディングカード", "ブロックチェーン事業開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">TRADING CARD NFT</span>
        <span className="cover-ja">トレーディングカード × NFT</span>
      </>
    ),
  },
  {
    slug: "asset-sim",
    meta: "金融サービス会社",
    title:
      "資産運用のシミュレーションから、アドバイザーとの面談につなげるリード獲得システム",
    tags: ["金融・資産運用", "Webシステム開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">LEAD GENERATION</span>
        <span className="cover-ja">資産運用 × Webシステム</span>
      </>
    ),
  },
  {
    slug: "defi",
    meta: "暗号資産運用会社",
    title: "DeFi運用を安全に任せられる、ウォレット制御と自動リバランスの設計",
    tags: ["金融・暗号資産", "ブロックチェーン事業開発"],
    isCover: true,
    cover: (
      <>
        <span className="cover-en">DeFi OPERATION</span>
        <span className="cover-ja">DeFi × ウォレット設計</span>
      </>
    ),
  },
];

export const SERVICE_FILTERS = [
  "AIインテグレーション",
  "ブロックチェーン事業開発",
  "Webシステム開発",
  "ブランディング・Web制作",
];
export const INDUSTRY_FILTERS = [
  "旅行・観光",
  "イベント・観光",
  "メタバース・エンタメ",
  "出版",
  "アパレル・ファッション",
  "地域創生",
  "教育・保育",
  "トレーディングカード",
  "金融・資産運用",
  "金融・暗号資産",
  "エンタープライズ",
];

export const findCase = (slug) => CASES.find((c) => c.slug === slug);
